export const TOPBAR_HEIGHT = 45;

export const APP = 'app';
export const ADSTATES = 'adStates';
export const ADSTATE_CONTAINERS = 'adStateContainers';
export const COMPONENTS = 'components';
export const SUBCOMPONENTS = 'subComponents';
export const KEYFRAMES = 'keyframes';
export const VARIANTS = 'variants';
export const KEYS = 'keys';
export const ASSETIDS = 'assetIds';
export const ASSETS = 'assets';
export const PAST = 'past';
export const PRESENT = 'present';
export const FUTURE = 'future';
export const AD = 'ad';
export const PREVIEW = 'preview';
export const LAYOUTS = 'layouts';
export const METADATA = 'metadata';
export const UI = 'ui';
export const FONTS = 'fonts';
export const VIEWPORT = 'viewport';
export const SELECTED = 'selected';
export const WIDTH = 'width';
export const HEIGHT = 'height';
export const TOP = 'top';
export const LEFT = 'left';
export const KEY = 'key';

export const LAYOUTS_PATH = [APP, PRESENT, PREVIEW, LAYOUTS];
export const ADSTATES_PATH = [APP, PRESENT, AD, ADSTATES];
export const ADSTATE_CONTAINERS_PATH = [APP, PRESENT, PREVIEW, ADSTATE_CONTAINERS];



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/constants/index.js